import script from "./DeliveryList.vue?vue&type=script&setup=true&lang=js"
export * from "./DeliveryList.vue?vue&type=script&setup=true&lang=js"

import "./DeliveryList.vue?vue&type=style&index=0&id=0ca7eff0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ca7eff0"]])

export default __exports__